module.exports = __webpack_public_path__ + "static/media/pepper-hot.ce8799b6.svg";